import { observable, action, makeObservable, set } from 'mobx';

import { AcquiringOperationType } from '../../shared/support/modelTypes';

export interface AcquiringOperationFormStoreType {
	model: AcquiringOperationType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude: Array<any>;
	selectedItems: Array<any>;
	requiredToFill: Array<{ predefinedName: string; property: string; relation: string }>;
	isFirstLoad: boolean;
	name: string;
	isSequenceNumberChangedManually: boolean;
	searchText: string;
	setValue(model: any, key: string, value: any): void;
}

class AcquiringOperationFormStore implements AcquiringOperationFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			filterInclude: observable,
			selectedItems: observable,
			requiredToFill: observable,
			isFirstLoad: observable,
			name: observable,
			isSequenceNumberChangedManually: observable,
			searchText: observable,
			setValue: action
		});
	}

	model = {
		amount: 0,
		contractId: null,
		deleted: false,
		organizationId: null,
		ownerId: null,
		ownerType: null,
		partnerId: null,
		paymentOptionId: null,
		posted: false,
		typeId: null,
		operationId: null,
		statusId: null,
		periodAt: null,
		resolveCallbackUrl: null,
		rejectCallbackUrl: null,
		responsibleId: null,
		authorId: null,
		specificationItemList: [],
		specificationItems: []
	};
	searchText = '';
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	isSequenceNumberChangedManually = false;
	pluralName = 'acquiringOperations';
	filterInclude = [
		'partner',
		'organization',
		'status',
		'contract',
		'paymentOption',
		'type',
		{
			relation: 'specificationItems',
			scope: {
				include: ['order', 'document', 'partner', 'contract', 'organization']
			}
		}
	];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	requiredToFill = [
		{
			predefinedName: 'DefaultOrganization',
			property: 'organizationId',
			relation: 'organization'
		},
		{
			predefinedName: 'DefaultPaymentOption',
			property: 'paymentOptionId',
			relation: 'paymentOption'
		}
	];
	isFirstLoad = true;
	name = 'OrmAcquiringOperation';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const acquiringOperationFormStore = new AcquiringOperationFormStore();

export default AcquiringOperationFormStore;
